// extracted by mini-css-extract-plugin
module.exports = {"vsTable":"index-module--vsTable--36Mqo"};